import React from 'react'

export default function SucessfullySubmited({ handleSucessfulyfalse, handleQuestionfalse }) {
    return (
        <div className='ContainerSubmitedSucess '>
            <div className='SubContainerSubmitedSucess'>
                <div className='d-flex justify-content-center align-items-center' >
                    <img src='/HwImg/sucessIcon.png' alt='' />
                </div>
                <div className='d-flex justify-content-center align-items-center mt-4 sucessMsg1' >You Have successfully Review the homework</div>
                <div className='d-flex justify-content-center align-items-center mt-2 sucessMsg2'>Once teacher evaluates, you will be notified</div>
                <div className='d-flex justify-content-center align-items-center mt-3'>

                    <button className='okayBtnsucess'
                        onClick={() => {
                            handleSucessfulyfalse();
                            // handleQuestionfalse()
                        }}
                    >Okay</button>
                </div>
            </div>
        </div>
    )
}
